import PropTypes from 'prop-types';
import React from 'react';
import { translate as t } from '../../lib/I18n';
import FormGroup from 'react-bootstrap/lib/FormGroup';

import { PassengerTypes } from '../../constants/AppConstants';
import Radio from '../form/Radio';

function PassengerType({ passengerType, onChange }) {
    const _handleChange = (event) => {
        onChange(event.target.value);
    };

    return (
        <section className="booking__section">
            <FormGroup className="ticket-type radio-group">
                <fieldset className="hidden-fieldset">
                    <legend className="sr-only">{ t('season.passengers.header') }</legend>
                    <Radio name="passenger"
                        radioClass="regular-radio"
                        value={ PassengerTypes.ADULT }
                        onChange={ _handleChange }
                        label={ t('season.passenger.adult') }
                        checked={ passengerType === PassengerTypes.ADULT }
                        inline
                        srOnly={ t('ariaLabel.seasonPassenger', { passenger: PassengerTypes.ADULT }) }
                    />
                    <Radio name="passenger"
                        radioClass="regular-radio"
                        value={ PassengerTypes.CHILD }
                        onChange={ _handleChange }
                        label={ t('season.passenger.child') }
                        checked={ passengerType === PassengerTypes.CHILD }
                        inline
                        srOnly={ t('ariaLabel.seasonPassenger', { passenger: PassengerTypes.CHILD }) }
                    />
                </fieldset>
            </FormGroup>
        </section>
    );
}

PassengerType.propTypes = {
    passengerType: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

PassengerType.defaultProps = {
    passengerType: PassengerTypes.ADULT
};

export default PassengerType;



// WEBPACK FOOTER //
// ./src/components/seasonTicket/Passenger.js